import React from 'react'
import UpdateBudget from 'src/app/UpdateBudget/UpdateBudget'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateBudgetRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateBudgetAppRoute: AppRoute = {
  id: AppLocation.UpdateBudget,
  routeProps: updateBudgetRouteProps,
  component: <UpdateBudget />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateBudgetAppRoute
